export function cloneComponentList(componentList = []) {
  return componentList.map((item) => ({
    ...item,
    dropdown: Array.isArray(item.dropdown) ? [...item.dropdown] : [],
  }));
}

export function isCloudIx(componentList = []) {
  return componentList.some(
    (item) =>
      item?.name === "IX version" &&
      String(getComponentValue(item) || "").includes("Cloud IX"),
  );
}

export function isCloudIxIssueTypeField(component) {
  return component?.name === "Cloud IX issue type";
}

export function isComponentVisible(component, componentList) {
  if (isCloudIxIssueTypeField(component)) {
    return isCloudIx(componentList);
  }

  return true;
}

export function isComponentRequired(component, componentList) {
  if (isCloudIxIssueTypeField(component)) {
    return isCloudIx(componentList);
  }

  return Boolean(component?.required);
}

export function getDescriptionPlaceholder(component, labels, componentList) {
  if (component?.id !== "description") {
    return component?.placeholder || "";
  }

  if (component?.useConfiguredPlaceholder && component?.placeholder) {
    return component.placeholder;
  }

  return isCloudIx(componentList)
    ? labels?.descriptionCloudPlaceholder || component?.placeholder || ""
    : labels?.descriptionPhysicalPlaceholder || component?.placeholder || "";
}

export function getComponentValue(component) {
  if (!component) {
    return "";
  }

  if (component.type === "dropdown") {
    if (typeof component.value === "string") {
      return component.value;
    }

    return component.value?.value || "";
  }

  return component.value || "";
}

export function validateComponent(component, componentList) {
  if (!isComponentVisible(component, componentList)) {
    return "";
  }

  const value = String(getComponentValue(component) || "").trim();
  const required = isComponentRequired(component, componentList);

  if (required && !value) {
    return "required";
  }

  if (
    component?.type === "email" &&
    value &&
    !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)
  ) {
    return "email";
  }

  if (component?.maxLength && value.length > component.maxLength) {
    return "maxLength";
  }

  return "";
}
